export default __webpack_public_path__ + "static/25-7096d7c06f89ccc5f55e87c97374f709.png";